import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/utilities/axios-global'
import { Message } from 'element-ui'

import home from './modules/home/store'
import user from './modules/user/store'
import reviews from './modules/reviews/store'
import documents from './modules/documents/store'
import requests from './modules/requests/store'
import emailAlerts from './modules/emailAlerts/store'
import reports from './modules/reports/store'
import dashboard from './modules/dashboard/store'
import codingQuestions from './modules/codingQuestions/store'
import globals from './modules/globals/store'
import onedrive from './modules/onedrive/store'
import userAdmin from './modules/userAdmin/store'
import notifications from './modules/notifications/store'
import myProjects from './modules/myProjects/store'
import rebuttals from './modules/rebuttals/store'
import clientCoders from './modules/clientCoders/store'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    home,
    user,
    reviews,
    documents,
    requests,
    emailAlerts,
    reports,
    dashboard,
    codingQuestions,
    globals,
    onedrive,
    userAdmin,
    notifications,
    myProjects,
    rebuttals,
    clientCoders
  },
  state: {
    buildNumber: undefined,
    showUpdateMessage: false
  },
  mutations: {
    SET_BUILD_NUMBER(state, payload) {
      state.buildNumber = payload
    },
    SET_SHOW_UPDATE_MESSAGE(state, payload) {
      state.showUpdateMessage = payload
    }
  },
  actions: {
    GET_BUILD_NUMBER() {
      return new Promise((resolve, reject) => {
        axios.get(process.env.VUE_APP_API_BASE_URL + '/api/utilities/version').then(response => {
          resolve(response)
        }, error => {
          console.log(error)
          reject(error)
        })
      })
    },
    showSuccessMessage(context, payload) {
      Message({
        message: payload,
        type: 'success'
      })
    },
    showErrorMessage(context, payload) {
      if (payload.response) {
        Message({
          message: payload.response.data.message,
          type: 'error'
        })
      } else {
        Message({
          message: 'Server Error',
          type: 'error'
        })
      }
    }
  }
})
